import { render } from "./BaseCarouselCenter.vue?vue&type=template&id=548e49a9&scoped=true"
import script from "./BaseCarouselCenter.vue?vue&type=script&lang=js"
export * from "./BaseCarouselCenter.vue?vue&type=script&lang=js"

import "./BaseCarouselCenter.vue?vue&type=style&index=0&id=548e49a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548e49a9"]])

export default __exports__